import EmbeddedCardLayout from '../../../components/embedded/CardLayout';
import EmbeddedCaption from '../../../components/embedded/Caption';
import EmbeddedNeedHelpSection from '../../../components/embedded/NeedHelpSection';
import EmbeddedRequestedDataCard from '../../../components/embedded/RequestedDataCard';
import { TRUST_CENTER_LINKS } from '../../../data/trustCenterLinks';
import { type FlowAction } from '../../../types';
import { useEmbeddedCopy } from '../../../hooks/useEmbeddedCopy';

/**
 * "What is shared" (or added): the requested data, by name only. The help row
 * links to Ver.iD's privacy policy and security page, in a new tab.
 */
export default function EmbeddedDetailsScreen({ back }: { back: FlowAction }) {
  const { t, pick, org, groups } = useEmbeddedCopy();
  return (
    <EmbeddedCardLayout
      secondary={back}
      help={
        <EmbeddedNeedHelpSection
          links={[
            {
              label: t('embedded.details.privacy'),
              href: TRUST_CENTER_LINKS.privacyPolicy,
            },
            {
              label: t('embedded.details.security'),
              href: TRUST_CENTER_LINKS.security,
            },
          ]}
        />
      }
    >
      <EmbeddedRequestedDataCard
        label={t(
          pick('embedded.details.label', 'embedded.details.labelIssuance'),
        )}
        groups={groups}
      />
      <EmbeddedCaption
        text={t(
          pick('embedded.details.caption', 'embedded.details.captionIssuance'),
        )}
        bold={org}
      />
    </EmbeddedCardLayout>
  );
}
